import { Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, Renderer2, RendererFactory2, SimpleChanges, ViewChild } from '@angular/core';
import { NgSelectComponent } from '@ng-select/ng-select';
import { GlobalService } from 'app/global/global.service';
import { DroplistOptions, Field } from 'app/interfaces/fields';
import { Subject, Subscription, delay, of, take, takeUntil } from 'rxjs';
import uuid from 'short-unique-id';
import { DocumentFieldService } from '../../settings/documentfields/documentfield.service';
import { Blocks } from '../blocks/blocks';
import { Fields } from '../fields/fields';
import { applyRelations } from 'app/global/fieldrelation';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MetaDataFormComponent } from '../../settings/documentfields/meta-data-form/meta-data-form.component';
import { DocumentFieldEmitterService, EmitterOptions } from 'app/global/documentfield-emitter.service';
import { IntegrationService } from 'app/global/integrations/integrations.service';
import { TranslocoService } from '@jsverse/transloco';
import { Roles } from '../../settings/contentlibrary/store/content-library-store.dto';
import { FindAndReplaceService } from './find-and-replace.service';
import { FieldSettings } from '../../events/editor-emitter.dto';
import { ConditioanlsFeilds, Currency, FieldTypes, SelectedColumnSize, SelectedFieldStyle, SelectedFontSize, SelectedRole } from './general-popover-settings.dto';
import { IMetadataItemDto } from '../../settings/documentfields/metadata-item.dto';
import { RecipientRole } from '../../edit-template/edit-template.dto';
import { ContentTabService } from '../content-tab/content-tab.service';
import { SelectedFieldBlock, SelectedFieldEnum } from 'app/interfaces/fields.dto';
import { EditorEmitterService } from '../../events/editor-emitter.service';
import { SessionImageService } from 'app/global/session-image.service';
import { ConditionalService } from './conditional/conditional.service';
import { DomHandlersService } from 'app/global/dom-handlers.service';
import { AbstractUpdateFieldsComponent } from '../fields-builder-service/abstract-update-fields-data.component';
import { MomentPipe } from 'app/pipes/moment.pipe';
import { FieldsBuilderService } from '../fields-builder-service/fields-builder.service';
import { DocumentHelperFacade } from '../../documents/document-right-sidebar/document-helper.facade';
import { FieldRenderService } from '../../edit-template/field-render.service';
import { FieldsDataHelperService } from '../fields-builder-service/fields-data-helper.service';
import { DomHelperService } from 'app/global/dom-helper.service';
import { UserFieldsService } from './user-fields/user-fields.service';
import { DocumentFieldsFacade } from '../../settings/documentfields/store/documentfields.facade';
import { EventHandlersService } from '../../edit-template/event-handler.service';
import { ValidationHandlerService } from 'app/global/validation-handler/validation-handler.service';

declare let $;
@Component({
  selector: 'app-general-popover-settings',
  templateUrl: './general-popover-settings.component.html',
  styleUrls: ['./general-popover-settings.component.scss'],
  providers: [Fields, Blocks]
})
export class GeneralPopoverSettingsComponent extends AbstractUpdateFieldsComponent implements OnChanges, OnInit, OnDestroy {

  /**
   * 
   * @param template 
   * @param contenttab 
   * @param Fields 
   * @param globalService 
   * @param documentFieldService 
   */
  constructor(
    private contenttab: ContentTabService,
    private Fields: Fields,
    private globalService: GlobalService,
    private documentFieldService: DocumentFieldService,
    private modalService: NgbModal,
    private fieldEmitter: DocumentFieldEmitterService,
    private integrationService: IntegrationService,
    public _translocoService: TranslocoService,
    private findAndReplaceService: FindAndReplaceService,
    public rendererFactory: RendererFactory2,
    private editorEventEmitter: EditorEmitterService,
    private sessionImageService: SessionImageService,
    private conditionalService: ConditionalService,
    public _momentPipe$: MomentPipe,
    public _integrationService: IntegrationService,
    private domHandlerService: DomHandlersService,
    private domHelperService: DomHelperService,
    public _modalService: NgbModal,
    public _fieldsBuilderService: FieldsBuilderService,
    public _documentHelperFacade: DocumentHelperFacade,
    private _fieldRenderService: FieldRenderService,
    _fieldsDataHelperService: FieldsDataHelperService,
    private userFieldsService: UserFieldsService,
    private documentFieldsFacade: DocumentFieldsFacade,
    private eventHandlersService: EventHandlersService,
    private validationHandlerService: ValidationHandlerService
  ) {
    super(
      globalService,
      fieldEmitter,
      _momentPipe$,
      rendererFactory,
      _integrationService,
      _modalService,
      _fieldsBuilderService,
      _translocoService,
      _documentHelperFacade,
      _fieldsDataHelperService
    );
    this.renderer = rendererFactory.createRenderer(null, null);
  }
  @Input() data: FieldSettings;
  @Input('customRoles')
  get customRoles(): Roles[] {
    return this.libraryRoles;
  }
  set customRoles(value: Roles[]) {
    this.libraryRoles = value || [];
  }
  @ViewChild('roleSelecter') roleSelecter;
  @ViewChild('label', { static: false }) label: ElementRef;
  @ViewChild('field_type', { static: false }) set field_type_content(content: NgSelectComponent) {
    if (content) {
      this.timeOutSubscription = of(null).
        pipe(
          delay(0),
          take(1)
        ).subscribe(() => {
          this.field_type = content;
        })
    }
  }
  public renderer: Renderer2;
  public libraryRoles: Roles[] = [];
  public select_selectFontSize;
  public clearButton: HTMLElement = document.createElement('button');
  public conditional_fields_textField;
  public text_field_selectFontSize;
  private field_type: NgSelectComponent;
  public unique_id = new uuid({ length: 6, dictionary: 'number' });
  public readonly: boolean = false;
  public searchable: boolean = false;
  public fieldPreviousClass: string = 'fill-aligned-label';
  public isRequired: boolean = true;
  public isPreChecked: number = 0;
  public isMultiChoiceChecked: number = 0;
  public isMultiLinesChecked: number = 0;
  public isConditionalChecked: boolean = false;
  public slashCommandTable: boolean = false;
  public isLabelHide: number = 0;
  public currentElement = null;
  public placeholderName: string = "";
  public labelName: string = "";
  public showLabel: string | number = "0";
  public multiChoiceOption: Array<DroplistOptions[]> = [];
  public preAddMultiChoiceOption: Array<DroplistOptions[]> = [];
  public fieldSelectedType: string = "1";
  public isTagView: number = 0;
  public addonpermissions = { hide_options: false };
  public SelectedFieldEnum = SelectedFieldEnum;
  public api_field: number | boolean = false;

  fieldtype: Array<FieldTypes> = [];
  field_info: string = 'me';

  public selectedRole: number | string = 0;
  selectRole: Array<SelectedRole> = [];

  public selectedCurrency: number = 1;
  currency: Array<Currency> = [
    { id: 1, name: 'USD, US dollars' },
    { id: 2, name: 'EUR, Euros' },
  ];

  public selectedFontSize: string = '14';
  selectFontSize: Array<SelectedFontSize> = [
    { id: 1, name: '10', fieldClass: 'field-size-10' },
    { id: 2, name: '12', fieldClass: 'field-size-12' },
    { id: 3, name: '14', fieldClass: 'field-size-14' },
    { id: 4, name: '16', fieldClass: 'field-size-16' },
    { id: 5, name: '18', fieldClass: 'field-size-18' },
    { id: 6, name: '20', fieldClass: 'field-size-20' },
    { id: 7, name: '22', fieldClass: 'field-size-22' },
    { id: 8, name: '24', fieldClass: 'field-size-24' },
    { id: 9, name: '26', fieldClass: 'field-size-26' },
    { id: 10, name: '28', fieldClass: 'field-size-28' },
    { id: 11, name: '30', fieldClass: 'field-size-30' },
  ];

  public fields_style: SelectedFieldStyle[] = [
    {
      id: 1,
      name: this._translocoService.translate("Field setting filled option (Template/Document - section) - Filled"),
      class: 'fill-aligned-label',
    },
    {
      id: 2,
      name: this._translocoService.translate("Field setting top (Template/Document - section) - Top"),
      class: 'top-aligned-label',
    },
    {
      id: 3,
      name: this._translocoService.translate("Field setting bottom  (Template/Document - section) - Bottom"),
      class: 'bottom-aligned-label',
    },
    {
      id: 4,
      name: this._translocoService.translate("Field setting left (Template/Document - section) - Left"),
      class: 'left-aligned-label',
    }
  ];
  public selectedFieldStyle: string = this.fields_style[0].name;
  public selectedColumnSize: number = 50;
  selectColumnSize: Array<SelectedColumnSize> = [
    { id: 100, name: '100%' },
    { id: 50, name: '50%' },
  ];
  fieldData: Field;
  private documentfields = ['', 'text', 'checkbox', 'droplist', 'datepicker', 'signature', 'droplist'];
  public generalpopup: boolean = true;
  private autoOpenDropDown: boolean = false;
  private editor = null;
  public timeOutSubscription: Subscription;
  public enable_conditional: number = 0;
  public conditional_fields: Array<ConditioanlsFeilds> = [];
  public selectedConditioanl = [];
  public fieldBlock: SelectedFieldBlock = SelectedFieldBlock.PdfField;
  public field_section: string = "";
  private destroyed = new Subject<void>();
  private timeoutId?: ReturnType<typeof setTimeout>;
  public isTransparent: number = 0; // 0 = false, 1 = true
  ngOnInit(): void {
    this.fieldEmitter.getData().pipe(takeUntil(this.destroyed)).subscribe((response: EmitterOptions) => {
      if (response?.refresh != undefined && response.refresh == 1) {
        this.timeoutId = setTimeout(() => {
          this.updateFields(true);
        }, 1000);
      }
    })
  }

  /**
   * update the properties when execute the component
   */
  updateFields(onlyUpdateFields = false) {
    this.fieldData = this.globalService.fields_data[this.data['uuid']];
    if (!onlyUpdateFields) {
      this.setupAllFields();
    }
    this.currentElement = $('.drag-fields[uuid="' + this.data['uuid'] + '"]');
    this.field_info = ((typeof this.fieldData != 'undefined' ? this.fieldData.field_info : 'me'));
    this.isRequired = this.fieldData?.field_required == "1" ? true : false;
    this.isMultiChoiceChecked = Number((typeof this.fieldData != 'undefined' && this.fieldData.multi_choice) ? this.fieldData.multi_choice : 0);
    this.isMultiLinesChecked = Number((typeof this.fieldData != 'undefined' && this.fieldData.allow_multi_lines) ? this.fieldData.allow_multi_lines : 0);
    this.slashCommandTable = ((typeof this.currentElement.attr('slashcommandtable') == 'undefined' ? false : this.currentElement.attr('slashcommandtable') == 1 ? true : false));
    this.isLabelHide = Number((typeof this.fieldData != 'undefined' && this.fieldData.hide_label) ? this.fieldData.hide_label : 0);
    this.isTransparent = Number((typeof this.fieldData != 'undefined' && this.fieldData.transparent) ? this.fieldData.transparent : 0);
    this.isPreChecked = Number((typeof this.fieldData != 'undefined' && this.fieldData.pre_checked) ? this.fieldData.pre_checked : 0);
    this.selectedFontSize = ((typeof this.fieldData != 'undefined' && this.fieldData.field_fontsize) ? this.fieldData.field_fontsize : '14');
    this.selectedColumnSize = Number((typeof this.fieldData != 'undefined' && this.fieldData.column) ? this.fieldData.column : 50);
    this.fieldSelectedType = (typeof this.fieldData != 'undefined' && this.fieldData.prefixid) ? String(this.fieldData.prefixid) : '1';
    this.selectedRole = (typeof this.fieldData != 'undefined' && this.fieldData.selected_for_role_id) ? (isNaN(Number(this.fieldData.selected_for_role_id)) ? this.fieldData.selected_for_role_id : Number(this.fieldData.selected_for_role_id)) : 0;
    this.selectedFieldStyle = ((typeof this.currentElement.attr('field_style') == 'undefined' ? 'Filled' : this.fields_style.find((result) => result.id == this.currentElement.attr('field_style')).name));
    this.labelName = (typeof this.fieldData != 'undefined' ? this.fieldData.select_type_text : 'New field');
    this.placeholderName = (typeof this.fieldData != 'undefined' ? this.fieldData.placeholder : '');
    this.isTagView = (typeof this.fieldData != 'undefined' && this.fieldData.tag_view) ? Number(this.fieldData.tag_view) : 0;
    this.multiChoiceOption = this.getData(this.data['uuid']);
    this.preAddMultiChoiceOption = this.getData(this.data['uuid']);
    this.autoOpenDropDown = this.data['autoOpenDropDown'] || false;
    this.editor = this.data['editor'] || null;
    this.enable_conditional = ((typeof this.fieldData != 'undefined' && this.fieldData.enable_conditional) ? this.fieldData.enable_conditional : 0)
    this.fieldBlock = ((typeof this.fieldData != 'undefined' && this.fieldData.field_block) ? Number(this.fieldData.field_block) : SelectedFieldBlock.PdfField);
    this.field_section = ((typeof this.fieldData != 'undefined' && this.fieldData.field_section) ? this.fieldData.field_section : '');
    this.api_field = (typeof this.fieldData != 'undefined' ? this.fieldData.api_field : false);
    const useraddons = this.globalService?.user_settings?.workspaces?.find(x => x.default == true)?.addon_setting;
    if (useraddons?.length) {
      const permission = useraddons.some((v) => v.key == 'DSP' && v.active === true);
      this.addonpermissions['hide_options'] = permission ? true : false;
    }
    this.showLabel = this.fieldSelectedType;
    if (this.isTagView == 1) {
      this.labelName = this.fieldData.select_type_text || "";
    }
    this.editorEventEmitter.updateEditor.next(null);
  }

  /**
   * component emitter when execute the component
   * @param changes 
   */
  ngOnChanges(changes: SimpleChanges) {
    if (changes['data']) {
      this.data = changes['data'].currentValue;
      this.updateFields();
    }
  }
  
  //setup sender,recipient,document fields
  async setupAllFields() {
    this.generalpopup = true;
    const allfields: FieldTypes[] = await this.userFieldsService.getAllFieldsAsync();
    this.selectRole = [
      { name: this._translocoService.translate("Field setting sender text (Template/Document - section) - Sender"), id: 0, color: '#28c76f', recipient: '' },
      { name: this._translocoService.translate("Field setting anyone (Template/Document - section) - Anyone"), id: -1, color: '#28c76f', recipient: '' }
    ];
    if (this.data && this.data['selected_field'] == SelectedFieldEnum.SignatureField) {
      this.selectRole = this.selectRole.filter((role: SelectedRole) => role?.id != -1);
    }
    for (let index = 0; index < this.globalService.roles.length; index++) {
      const role: RecipientRole = this.globalService.roles[index];
      this.selectRole.unshift({ id: role.id, name: role.role_name, color: role.role_color, recipient: (role.recipient_id ? `${role.recipient.firstname} ${role.recipient.lastname ?? ''}` : ''), recipient_id: role.recipient_id });
      const nonImagePersonFields = role.personfields.filter(f => f.metadata_type !== 'image');
      for (let index1 = 0; index1 < nonImagePersonFields.length; index1++) {
        const personfields = nonImagePersonFields[index1];
        if (personfields.is_enable && personfields.key !== 'last_name') {
          allfields.push({
            id: `${personfields.id}`,
            name: `${personfields.is_default === 1 ? (personfields.key === 'first_name' ? this._translocoService.translate("Full name (general) - Full name") : this._translocoService.translate(personfields?.translation)) : personfields.name}`,
            value: (personfields.key === 'first_name' && role.recipient_id) ? `${role.recipient.firstname} ${role.recipient.lastname ?? ''}` : personfields.value ?? '',
            key: personfields.key,
            field_type: role.role_name,
            field_info: 'recipient_field',
            field_required: `${personfields.required}`,
            prefixid: `${personfields.id == 0 ? personfields.name + role.role_name : personfields.id}`,
            role_id: `${role.id}`,
            role_data: role,
            field_section: "person_field",
            validation: personfields.validations ?? {},
            color: role.role_color,
            recipient_id: role.recipient_id,
            lock: personfields?.lock ?? 0
          });
        }
      }
      const nonImageOrgFields = role.orgfields.filter(f => f.metadata_type !== 'image');
      for (let index1 = 0; index1 < nonImageOrgFields.length; index1++) {
        const orgfields = nonImageOrgFields[index1];
        if (orgfields.is_enable == 1) {
          allfields.push({
            id: `${orgfields.id}`,
            name: orgfields.is_default === 1 ? this._translocoService.translate(orgfields?.translation) : orgfields.name,
            value: `${orgfields.value ?? ''}`,
            key: orgfields.key,
            field_type: `${role.role_name} (${this._translocoService.translate("Field setting org (Template/Document - section) - Org")})`,
            field_info: 'recipient_field',
            field_required: `${orgfields.required}`,
            prefixid: `${orgfields.id == 0 ? orgfields.name + role.role_name : orgfields.id}`,
            role_id: `${role.id}`,
            role_data: role,
            field_section: "org_field",
            validation: orgfields.validations ?? {},
            color: role.role_color,
            recipient_id: role.recipient_id,
            lock: orgfields?.lock ?? 0
          });
        }
      }
    }
    if (typeof this.fieldData != 'undefined') {
      this.documentFieldsFacade.getFieldsByType([this.documentfields[this.fieldData.selected_field]]).pipe(takeUntil(this.destroyed)).subscribe(fields => {
        const documenttypes = fields || [];
          for (let index = 0; index < documenttypes.length; index++) {
            const type = documenttypes[index];
            allfields.push({
              id: type.id,
              name: `${type.meta_data_name}`,
              description: `${type.meta_data_description}`,
              multiple_line_field: type.multiple_line_field,
              multi_select: type?.multi_select ?? 0,
              value: ``,
              field_type: `${this._translocoService.translate("Field setting doc field (Template/Document - section) - Doc field")}`,
              field_info: "document_field",
              field_required: `${type.is_required}`,
              api_attribute: `${type.api_attribute}`,
              prefixid: `d${type.id}`,
              options: type.meta_data_option ?? [],
              api_field: type?.api_field ?? 0,
              api_url: type?.api_url ?? '',
              api_key: type?.api_key ?? '',
              role_data: {},
              field_section: "document_field",
              source: type?.source,
              validation: type.field_validations ?? {},
              color: '',
              recipient_id: 0
            });
          }
          this.fieldtype = allfields;
          const validFields = [
            SelectedFieldEnum.DroplistField,
            SelectedFieldEnum.DatepickerField,
            SelectedFieldEnum.CheckboxField,
            SelectedFieldEnum.ListField
          ];
          // (this.fieldData['selected_field'] == "4" || this.fieldData['selected_field'] == "3") || this.fieldData['selected_field'] == "2" || this.fieldData['selected_field'] == "6"
          if (typeof this.fieldData != 'undefined' && validFields.includes(this.fieldData['selected_field'])) {
            this.fieldtype = allfields.filter((field) => field.field_info == 'document_field' || field.field_info == 'custom_field');
          }
          this.generalpopup = false;
          if (this.autoOpenDropDown && this.fieldData['selected_field'] != SelectedFieldEnum.SignatureField) {
            this.timeOutSubscription = of(null).
              pipe(
                delay(200),
                take(1)
              ).subscribe(() => {
                this.field_type.open();
              });
          }
      });
      this.fetchConditionalFields();

    } else {
      this.generalpopup = false;
    }
  }


  /**
   * delete fields settings
   */
  deleteSettings() {
    if (this.fieldBlock === SelectedFieldBlock.ContentField) {
      this.domHandlerService.deleteFieldBlock(this.data['uuid']);
    } else {
      this.contenttab.removeField(this.data['uuid'], this.data['formUuid']);
    }
    this.close()
  }


  /**
   * close the right side menu
   */
  close() {
    this.eventHandlersService.triggerEditorSideMenu({}, 'DEFAULT');
  }

  /**
   * change the font size
   * @param data 
   */
  changeFontSize(fontSize: SelectedFontSize) {
    this.currentElement = $('.drag-fields[uuid="' + this.data['uuid'] + '"]');
    this.selectedFontSize = fontSize.name;
    this.globalService.updateField(this.data['uuid'], { 'field_fontsize': fontSize.name });
    this.currentElement.attr('field_fontsize', fontSize.name);
  }

  /**
   * select the field style
   * @param style_type 
   * @param selected_fields 
   */
  selectFieldStyle(style_type, selected_fields) {
    this.currentElement = $('.drag-fields[uuid="' + this.data['uuid'] + '"]');
    this.selectedFieldStyle = selected_fields.name;
    this.currentElement.removeClass(this.fieldPreviousClass);
    this.currentElement.addClass(selected_fields.class);
    this.fieldPreviousClass = selected_fields.class;
    this.currentElement.attr('field_style', selected_fields.id);
  }


  /**
   * toggle the required change
   * @param event 
   */
  onRequiredChange(event) {
    this.currentElement = $('.drag-fields[uuid="' + this.data['uuid'] + '"]');
    this.isRequired = event.target.checked;
    this.globalService.updateField(this.data['uuid'], { 'field_required': (event.target.checked ? "1" : "0") })
    this.currentElement.attr('field_required', (event.target.checked ? 1 : 0));
    this.validationHandlerService.resetFieldHighlight(String(this.data['uuid']));
  }

  /**
   * toggle pre-checked
   * @param event 
   */
  onPreCheckedChange(event) {
    this.currentElement = $('.drag-fields[uuid="' + this.data['uuid'] + '"]');
    this.isPreChecked = (event.target.checked ? 1 : 0);
    this.globalService.updateField(this.data['uuid'], { value: this.isPreChecked, pre_checked: this.isPreChecked });
    applyRelations(this.data['uuid'], this.globalService);
    this.currentElement.toggleClass("checkbox-prechecked", this.isPreChecked);
  }

  /**
   * toggle the multiple choice
   * @param event 
   */
  onMultiChoiceChange(event) {
    this.currentElement = $('.drag-fields[uuid="' + this.data['uuid'] + '"]');
    this.isMultiChoiceChecked = event.target.checked;
    this.globalService.updateField(this.data['uuid'], { multi_choice: (event.target.checked ? 1 : 0), value: "" });
    this.currentElement.find('.multiChoice-item').removeClass('multiChoice-active');
    if (this.isMultiChoiceChecked) {
      this.currentElement.removeClass("multiChoice-radio").addClass("multiChoice-checkbox");
    } else {
      this.currentElement.removeClass("multiChoice-checkbox").addClass("multiChoice-radio");
    }
    applyRelations(this.data['uuid'], this.globalService);
    this.integrationService.fillingTag(this.globalService.fields_data[this.data['uuid']]);
  }

  /**
   * toggle the hide label
   * @param event 
   */
  hideLabel(event) {
    this.currentElement = $('.drag-fields[uuid="' + this.data['uuid'] + '"]');
    this.isLabelHide = event.target.checked;
    this.globalService.updateField(this.data['uuid'], { hide_label: (event.target.checked ? 1 : 0) });
    this.currentElement.find('.selected-label').toggleClass("hidden", this.isLabelHide);
  }

  transparentChange(event: Event) {
    const target = event.target as HTMLInputElement;
    const currentElement = document.querySelector(`.drag-fields[uuid="${this.data['uuid']}"]`);
    this.isTransparent = target.checked ? 1 : 0;

    // update the in-memory field (this will mark the template as having unsaved changes)
    this.globalService.updateField(this.data['uuid'], { transparent: this.isTransparent });

    // Update editor DOM so the designer sees the effect right away
    // signature-image is the element used by signature fields in editor content
    const signatureImage = currentElement.querySelector(`.signature-image`) as HTMLElement;
    if (signatureImage) {
      this.globalService.toggleClass(signatureImage, 'signature-transparent');
    }
  }

  /**
   * rename the field label text
   * @param event input dom
   */
  renameLabel(event) {
    this.currentElement = $('.drag-fields[uuid="' + this.data['uuid'] + '"]');
    this.labelName = event.target.value;
    if (this.isTagView == 1 && !this.fieldData.value) {
      this.currentElement.find('.selected-label').text(`[${event.target.value}]`);
    } else if (this.isTagView == 0) {
      this.currentElement.find('.selected-label').text(event.target.value);
    }
    this.globalService.updateField(this.data['uuid'], { 'selected_type': event.target.value.toLowerCase().replace(/ /g, "_"), 'select_type_text': event.target.value });
  }

  /**
   * rename placeholder
   * @param event 
   */
  renamePlaceholder(event) {
    this.currentElement = $('.drag-fields[uuid="' + this.data['uuid'] + '"]');
    this.placeholderName = event.target.value;
    this.globalService.updateField(this.data['uuid'], { 'placeholder': event.target.value });
    this.currentElement.find('input,textarea').attr('placeholder', event.target.value);
  }

  renameDroplistPlaceholder(event) {
    const currentElement = $('.drag-fields[uuid="' + this.data['uuid'] + '"]');
    this.placeholderName = event.target.value;
    if (currentElement.find('.droplist-option-label').length) {
      this.renderer.setAttribute(currentElement.find('.droplist-option-label')[0], 'droplistplaceholder', event.target.value);
    }
    this.globalService.updateField(this.data['uuid'], { 'placeholder': event.target.value });
  }

  /**
   * get droplist options
   * @param uuid 
   */
  getData(uuid) {
    try {
      // return JSON.parse($('[uuid="' + uuid + '"] script[type="text/json"]').text());
      return this.globalService.fields_data[uuid].options//JSON.parse($('[uuid="' + uuid + '"] #' + uuid + ' ').data('options'));
    } catch (err) { // if we have not valid json or dont have it
      return [];
    }
  }

  /**
   * set json in droplost option
   * @param index 
   * @param value 
   * @param action 
   */
  setData(index, value, action) {
    let options = this.getData(this.data['uuid']);
    switch (action) {
      case 'add':
        options.push(value);
        break;
      case 'update':
        options[index].name = value;
        options[index].value = value;
        break;
      case 'delete':
        options = options.filter(option => option.id != value);
        break;
    }
    this.globalService.updateField(this.data['uuid'], { options: options });
  }

  /**
   * add the options in dropdown
   * @param field_type 
   */
  addOption(field_type) {
    this.currentElement = $('.drag-fields[uuid="' + this.data['uuid'] + '"]');
    const uuid = this.unique_id();
    let optionElement = $();
    let optionList = '';
    let option = '';
    const totalOptions = this.getData(this.data['uuid']);
    if (field_type == 'multichoice') {
      optionElement = $(this.currentElement).find('.multiChoice-item-container');
      optionList = '.multiChoice-item';
      option = this.Fields.appendMultiChoiceField({ id: uuid, name: this._translocoService.translate("Content drop list option menu - (Template/Document - section) - Option") + ' ' + (Number(optionElement.find(optionList).length) + 1), value: this._translocoService.translate("Content drop list option menu - (Template/Document - section) - Option") + ' ' + (Number(optionElement.find(optionList).length) + 1), meta_data_id: 0 });
    } else if (field_type == 'droplist') {
      optionElement = $(this.currentElement).find('ng-dropdown-panel .scroll-host');
      optionList = '.ng-option';
      option = this.Fields.appendDroplistField({ id: uuid, name: this._translocoService.translate("Content drop list option menu - (Template/Document - section) - Option") + ' ' + (Number(optionElement.find(optionList).not('.not-found').length) + 1), value: this._translocoService.translate("Content drop list option menu - (Template/Document - section) - Option") + ' ' + (Number(optionElement.find(optionList).not('.not-found').length) + 1), meta_data_id: 0 });
    }
    if (field_type == 'multichoice') {
      optionElement.append(option);
    }
    this.setData(null, { id: uuid, name: this._translocoService.translate("Content drop list option menu - (Template/Document - section) - Option") + ' ' + (Number(totalOptions.length) + 1), value: this._translocoService.translate("Content drop list option menu - (Template/Document - section) - Option") + ' ' + (Number(totalOptions.length) + 1), meta_data_id: 0 }, 'add');
    this.multiChoiceOption = this.getData(this.data['uuid']);
     if (field_type === 'multichoice') {
      this.domHelperService.initializeEventListener(document.querySelectorAll('.multiChoice-box'), 'click', 'multiChoiceAction', { role_id: 0 });
     }
  }

  /**
   * set document field added options
   * @param field_type 
   * @param options 
   */
  preAddedOptions(field_type, options) {
    this.currentElement = $('.drag-fields[uuid="' + this.data['uuid'] + '"]');
    let optionElement = $();
    let option = '';

    if (field_type === 'multichoice') {
      optionElement = $(this.currentElement).find('.multiChoice-item-container');
      option = this.Fields.appendMultiChoiceField({ id: options.id, name: options.name });
    } else if (field_type === 'droplist') {
      optionElement = $(this.currentElement).find('ng-dropdown-panel .scroll-host');
      option = this.Fields.appendDroplistField({ id: options.id, name: options.name });
    }

    if (field_type === 'multichoice' && optionElement.length) {
      if (typeof option === 'string') {
        optionElement.append(option);
      } else {
        optionElement.append(option);
      }
    }
    this.preAddMultiChoiceOption = this.getData(this.data['uuid']);
  }

  /**
   * Rename custom option label
   * @param event 
   * @param option 
   * @param index 
   * @param field_type 
   */
  renameOption(event, option, index, field_type) {
    this.currentElement = $('.drag-fields[uuid="' + this.data['uuid'] + '"]');
    if (field_type == 'multichoice') {
      $(this.currentElement).find('.multiChoice-item[option_uuid="' + option.id + '"] label').text(event.target.value);
    } else if (field_type == 'droplist') {
      $(this.currentElement).find('.ng-option[option_uuid="' + option.id + '"] span').text(event.target.value);
      $(this.currentElement).find('.selected-option-label[option_uuid="' + option.id + '"]').text(event.target.value);
    }
    this.setData(index, event.target.value, 'update');
  }

  /**
   * delete custom droplist option
   * @param event 
   * @param option 
   * @param index 
   * @param field_type 
   */
  deleteOption(event, option, index, field_type) {
    this.currentElement = $('.drag-fields[uuid="' + this.data['uuid'] + '"]');
    if (field_type == 'multichoice') {
      $(this.currentElement).find('.multiChoice-item[option_uuid="' + option.id + '"]').remove();
    } else if (field_type == 'droplist') {
      $(this.currentElement).find('.ng-option[option_uuid="' + option.id + '"]').remove();
      $(this.currentElement).find('.selected-option-label[option_uuid="' + option.id + '"]').text('');
    }
    this.setData(index, option.id, 'delete');
    this.multiChoiceOption = this.getData(this.data['uuid']);
  }

  /**
   * allow multple lines for text field
   * @param event 
   */
  allowMultiLines(event) {
    this.currentElement = $('.drag-fields[uuid="' + this.data['uuid'] + '"]');
    this.isMultiLinesChecked = event.target.checked;
    this.processMultiLine(event.target.checked);
  }

  processMultiLine(allow_multi_line: boolean) {
    this.globalService.updateField(this.fieldData.uuid, { allow_multi_lines: (allow_multi_line ? 1 : 0) });

    if(this.isTagView === 1) {
      return;
    }

    if (allow_multi_line) {
      this.currentElement.addClass('allow-multirows');
    } else {
      this.currentElement.removeClass('allow-multirows');
    }
    this.currentElement.find('.text-field-textarea').toggleClass('hidden', !allow_multi_line);
    this.currentElement.find('.text-field-input').toggleClass('hidden', allow_multi_line);
    if (allow_multi_line) {
      const currentVal = this.currentElement.find('.text-field-input').val();
      this.currentElement.find('.text-field-textarea').val(currentVal);
    } else {
      const currentVal = this.currentElement.find('.text-field-textarea').val().replace(/(\r\n|\n|\r)/g, ' ');
      this.currentElement.find('.text-field-input').val(currentVal);
    }
    if (!this.data['isFormBuilder'] && !this.fieldBlock) {
      $(this.currentElement).css('height', '');
      this.currentElement.resizable("destroy");
      this.currentElement.resizable({
        containment: '.content-box',
        handles: allow_multi_line ? 'se' : 'e',
        resize() {
          if (allow_multi_line) {
            $(this).css('height', $(this).height())
          } else {
            //$(this).css('height', '')
          }
        },
      })
    } else {
      this.currentElement.find('input').toggleClass('hidden', allow_multi_line);
    }
  }

  /**
   * back to foem builder
   */
  backToFormBuilder() {
    this.eventHandlersService.triggerEditorSideMenu({ uuid: this.data['formUuid'] }, "FORMBUILDERSETTINGMENU");
  }

  /**
   * change the column size of field
   * @param data 
   */
  changeColumnSize(data) {
    this.currentElement = $('.drag-fields[uuid="' + this.data['uuid'] + '"]');
    this.selectedColumnSize = data.id;
    this.globalService.updateField(this.data['uuid'], { 'column': data.id });
    this.currentElement.attr('column', data.id);
  }




  /**
   * select the field type
   * @param type
   * @description
   * This method is used to change the field type when the user selects a different field type
   * @param {FieldTypes} type - The field type to be selected.
   * @example
   * ```typescript
   * this.onSelectTypeChange(type);
   * ```
   * @returns {void}
   * @memberof FieldSettingsComponent
   */
  onSelectTypeChange(type: FieldTypes): void {
    if(!this.isAlreadyFieldExists(type)) {
      return;
    }
    // If the field type is document field, we need to remove existing semi hidden fields
    const config = this.removeExistsingSemiHiddenField(type.id);
    type = {...type, ...config}

    const existingField = this.globalService.findMatchingField(this.globalService.fields_data, 'selected_field_type_id', type.id, 'document_field');

    if(type.field_section === 'document_field' && existingField?.length) {
      type.value = existingField?.find(field => field.value)?.value ?? '';
    }

    this.currentElement = $('.drag-fields[uuid="' + this.data['uuid'] + '"]');
    this.showLabel = type.id;
    this.fieldSelectedType = (type.prefixid == "0" && type.field_section != "custom" 
      ? type.name + type.field_type 
      : type.prefixid);
    this.field_info = type.field_info;
    this.isRequired = Number(type.field_required) == 1 ? true : false;
    this.currentElement.attr('field_required', (this.isRequired ? 1 : 0).toString());
    this.field_section = type.field_section;

    const fieldExists = this.globalService.findField(
      this.globalService.fields_data, 
      'selected_field_type_id', 
      type.id, 
      type.field_section
    );

    const isRecipientField = this.field_info === "recipient_field" 
      ? { "selected_for_role_id": type.role_id } 
      : {};

    this.updateInputFields(this.data['uuid'], type, isRecipientField, this.fieldSelectedType, true);

    const inputElem = this.currentElement.find('input,textarea');
    if (inputElem.length) {
      inputElem.attr('placeholder', type.name);
      inputElem.attr('value', type.value);
      inputElem.val(type.value);
    }

    this.placeholderName = type.name;
    this.api_field = type.api_field;

    if (this.isTagView == 1) {
      this.currentElement.find('.selected-label')
        .text(type.value === '' ? `[${type.name}]` : `${type.value}`);

      if (this.field_info === "recipient_field") {
        this.currentElement.find('.tag .selected-label').css('color', type.color);
      }
    } else {
      this.currentElement.find('.selected-label').text(type.name);
    }

    this.labelName = type.name;

    if (this.field_info == 'me') {
      this.currentElement.find('.tag .selected-label').css('color', '#28c76f');
    }

    if (this.showLabel == "0") {
      this.timeOutSubscription = of(null).
        pipe(
          delay(0),
          take(1)
        ).subscribe(() => {
          this.label.nativeElement.focus();
        });
    }
    this.allowEditableField();
    this.integrationService.fillingTag(this.globalService.fields_data[this.data['uuid']]);
    if (this.fieldData.tag_view === "0" && this.fieldData.type === "text") {
      this.processMultiLine((type.multiple_line_field ? true : false));
    }
    if (fieldExists && type.field_section != "custom") {
      if (fieldExists.connected_parent_conditional_id.length > 0) {
        this.conditionalService.onSelectRelations(fieldExists.connected_parent_conditional_id, (this.data as Field));
      }
      this.findAndReplaceField(this.data['uuid'], { ...fieldExists, ...config } as Field)
    }
    if (type.field_info === 'document_field') {
      this.findAndReplaceSemiHiddenField(existingField, { ...type, value: this.globalService.fields_data[this.data['uuid']]?.value }, this.fieldSelectedType);
    }
    this.renderFields();
    this.fetchConditionalFields();
    this.fieldEmitter.patchData({ refresh: 1 });
  }





  private renderFields(): void {
     if(this._fieldRenderService.isRendered(String(this.data['uuid'])) === false){
        this._fieldRenderService.markRendered(String(this.data['uuid']));
    }
  }




  /**
   * Check if field is already exists as secret hidden field
   * @param type 
   * @returns {boolean}
   */
  private isAlreadyFieldExists(type: FieldTypes): boolean {
    const secretField = this._globalService.findMatchingField(
      this._globalService.fields_data, 
      'selected_field_type_id', 
      type.id, 
      'document_field'
    )?.some(f => f.secret_hidden_field === 1);

    if (secretField) {
      this._globalService.toastrWarning("This field already exists in secret hidden field");
      return false;
    }
    return true;
  }



  private findAndReplaceField(uuid: number | string, field: Field): void {
    this.findAndReplaceService
      .findAndReplace(uuid, { ...field } as Field)
      .pipe(takeUntil(this.destroyed))
      .subscribe(() => this.updateFields(true));
  }





  /**
   * Removes an existing semi-hidden field from the global fields data if it matches the specified type ID.
   * Searches for a field where `semi_hidden_field` is set to `1`, `field_section` is `'document_field'`,
   * and `selected_field_type_id` matches the provided `selectedTypeId`.
   * If such a field is found, deletes it using its UUID and returns its value.
   * If no matching field is found, returns `null`.
   *
   * @param selectedTypeId - The ID of the field type to search for (string or number).
   * @returns The value of the removed field if found, otherwise `null`.
   */
  private removeExistsingSemiHiddenField(selectedTypeId: string | number) {
    const existingField: Field = Object.values(this.globalService.fields_data)
                          .find((field: Field) => 
                            ((field.semi_hidden_field === 1)) 
                            && field.field_section === 'document_field' 
                            && field.selected_field_type_id === selectedTypeId
                            && field.uuid !== this.data['uuid']
                          );
    
    if (!existingField) {
      return null; // No matching field found
    }
    
    this.globalService.deleteField(existingField.uuid);
    return {
      order: existingField?.order,
      value: existingField?.value || '',
      pinned_field: existingField.pinned_field,
      semi_hidden_field: existingField.semi_hidden_field,
      secret_hidden_field: existingField.secret_hidden_field,
    };
  }



  /**
   * find and replace semi hidden field
   * @description
   * This method is used to find and replace the semi hidden field.
   * 
   * @param {Field[]} existingField - The existing field.
   * @param {string} fieldSelectedType - The field selected type.
   * 
   * @example
   * @param existingField 
   * @param fieldSelectedType 
   * @example
   * ```typescript
   * this.findAndReplaceSemiHiddenField(existingField, this.fieldSelectedType);
   * ```
   * @returns {void}
   */
  private findAndReplaceSemiHiddenField(existingField: Field[], selectedField: FieldTypes, fieldSelectedType: string): void {
    existingField.forEach(field => {
      if (field.semi_hidden_field === 1) {
        if (field.selected_field === SelectedFieldEnum.DroplistField) {
          this.updateDropListData(field.uuid, { ...selectedField, semi_hidden_field: 1 } as Field, true)
        } else {
          this.updateInputFields(field.uuid, { ...selectedField, semi_hidden_field: 1 } as Field, {}, fieldSelectedType, true)
        }
      }
    });
  }




  /**
   * allow field editable for sender or anyone
   */
  allowEditableField() {
    if (this.fieldData.tag_view == "1" && this.fieldData.type == "droplist") {
      return;
    }
    this.setEditAbleFields(this.fieldData);
    const findFields = this.globalService.findMatchingField(this.globalService.fields_data, 'selected_field_type_id', this.fieldData.selected_field_type_id, this.fieldData.field_section);
    findFields.forEach((field: Field) => {
      if (field.uuid != this.fieldData.uuid && field.field_section != "custom") {
        this.setEditAbleFields(field);
      }
    });
  }

  setEditAbleFields(field: Field) {
    const selector = $('.drag-fields[uuid="' + field.uuid + '"]');
    if (selector.length) {
      const containers = selector.find('.fields-ele-container, .tag-container');
      if ((this.field_info == 'document_field' || this.field_info == 'custom_field') && (this.selectedRole == 0 || this.selectedRole == -1)) {
        containers.each((index, element) => {
          this.renderer.removeClass(element, 'pointer-none');
          const inputs = $(element).find('input, textarea');
          inputs.each((inputIndex, input) => {
            this.renderer.removeAttribute(input, 'tabindex');
          });
        });
        if (this.fieldData.type == 'datepicker' && this.isTagView == 0) {
          this.globalService.initializeFlatpicker($('[uuid="' + this.data["uuid"] + '"] .selected-label')[0]);
        }
      } else {
        containers.each((index, element) => {
          this.renderer.addClass(element, 'pointer-none');
          const inputs = $(element).find('input, textarea');
          inputs.each((inputIndex, input) => {
            this.renderer.setAttribute(input, 'tabindex', '-1');
          });
        });
        if (this.fieldData.type == 'datepicker') {
          this.globalService.destroyFlatpicker($('[uuid="' + this.data["uuid"] + '"] .selected-label')[0]);
        }
      }
    }
  }

  /**
   * change the droplist field type
   * @param droplist 
   * @param field_type 
   */
  onDroplistTypeChange(droplist: FieldTypes, field_type: string) {
    if(!this.isAlreadyFieldExists(droplist)) {
      return;
    }
    // If the field type is document field, we need to remove existing semi hidden fields
    const config = this.removeExistsingSemiHiddenField(droplist.id);
    droplist = {...droplist, ...config};

    const existingField = this.globalService.findMatchingField(this.globalService.fields_data, 'selected_field_type_id', droplist.id, 'document_field');

    if(droplist.field_section === 'document_field' && existingField?.length) {
      droplist.value = existingField?.find(field => field.value)?.value ?? '';
    }

    this.currentElement = $('.drag-fields[uuid="' + this.data['uuid'] + '"]');
    this.multiChoiceOption = [];
    this.currentElement.find('.multiChoice-item, .ng-option').each((index, item) => {
      if (!$(item).hasClass('not-found')) {
        $(item).remove();
      }
    });

    this.currentElement.find('.selected-option-label').attr('option_uuid', '0');
    this.currentElement.find('.selected-option-label').text('');

    this.showLabel = droplist.id;
    this.fieldSelectedType = droplist.prefixid;
    this.isRequired = Number(droplist.field_required) == 1 ? true : false;
    this.currentElement.attr('field_required', (this.isRequired ? 1 : 0).toString());
    this.field_section = droplist.field_section;
    const fieldExists = this.globalService.findField(this.globalService.fields_data, 'selected_field_type_id', droplist.id, droplist.field_section);
    this.updateDropListData(this.data['uuid'], droplist, true);
    if (droplist?.options && typeof droplist.options == 'object') {
      for (const option of droplist.options) {
        if (option.name) {
          this.preAddedOptions(field_type, option);
        }
      }
    }

    if (droplist.id == 0) {
      this.labelName = this._translocoService.translate("Content droplist select option (Template/Document - section) - Select option");
      this.currentElement.find('.selected-label').text(this._translocoService.translate("Content droplist select option (Template/Document - section) - Select option"));
      if (field_type == 'multichoice') {
        for (let index = 0; index < 2; index++) {
          this.addOption(field_type);
        }
      }
      this.timeOutSubscription = of(null).
        pipe(
          delay(0),
          take(1)
        ).subscribe(() => {
          this.label.nativeElement.focus();
        });
    } else {
      this.labelName = droplist.name;
      this.currentElement.find('.selected-label').text(droplist.name);
      this.integrationService.fillingTag(this.globalService.fields_data[this.data['uuid']]);
    }

    if (fieldExists && droplist.field_section !== "custom") {
      this.findAndReplaceService.findAndReplace(this.data['uuid'], { ...fieldExists } as Field).pipe(takeUntil(this.destroyed)).subscribe(() => {
        this.updateFields(true);
      });
    }
    if (droplist.field_info === 'document_field') {
      this.findAndReplaceSemiHiddenField(existingField, { ...droplist, value: this.globalService.fields_data[this.data['uuid']]?.value }, this.fieldSelectedType);
    }
    this.renderFields();
    this.fetchConditionalFields();
    this.domHelperService.initializeEventListener(document.querySelectorAll('.multiChoice-box'), 'click', 'multiChoiceAction', { role_id: 0 });
    this.fieldEmitter.patchData({ refresh: 1 });
  }

  /**
   * hide the option when click on eye icon
   * @param toggle 
   * @param index 
   * @param option 
   * @param field_type 
   * @param option_type 
   */
  hideOption(toggle: number, index: number, option: DroplistOptions, field_type: string, option_type = 'preadded') {
    this.currentElement = $('.drag-fields[uuid="' + this.data['uuid'] + '"]');
    const options = this.getData(this.data['uuid']);
    options[index].hide = toggle;
    if (option_type == 'preadded') {
      this.preAddMultiChoiceOption = this.getData(this.data['uuid']);
    } else {
      this.multiChoiceOption = this.getData(this.data['uuid']);
    }
    if (field_type == 'multichoice') {
      $(this.currentElement).find('.multiChoice-item[option_uuid="' + option.id + '"]').toggleClass('hidden', (toggle == 1 ? true : false));
    } else if (field_type == 'droplist') {
      $(this.currentElement).find('.ng-option[option_uuid="' + option.id + '"]').toggleClass('hidden', (toggle == 1 ? true : false));
    }
  }

  /**
   * Change role type, who will fill field.
   * @param role 
   */
  onChangeRoleType(role: SelectedRole) {
    this.currentElement = $('.drag-fields[uuid="' + this.data['uuid'] + '"]');
    this.globalService.updateField(this.data['uuid'], { 'selected_for_role_id': role.id, 'recipient_id': role.recipient_id });
    this.currentElement.find('.recipient-role').text(String(role.name).substring(0, 3).toLocaleUpperCase()).css('background', role.color);
    if (this.isTagView == 1) {
      this.currentElement.find('.tag .selected-label').css('color', `${role.color}`);
    }
    if (this.fieldData.selected_field == SelectedFieldEnum.SignatureField) {
      this.assignSignatureToRole(role)
    }
    this.allowEditableField();
    this.validationHandlerService.resetFieldHighlight(String(this.data['uuid']));
  }

  /**
   * assign signature to the role
   * @param role 
   */
  assignSignatureToRole(role) {
    this.globalService.assignSignatureToRole(role, this.data['uuid']);
  }


  fetchConditionalFields() {
    const uniqueKeepLast = (items: ConditioanlsFeilds[]) => Array.from(new Map(items.map(i => [i.uuid, i])).values());
    this.conditional_fields = this.conditionalService.fetchConditionalFields(this.data['uuid'], this.selectRole);
    const selectedUUIDs = [...this.conditional_fields.map(item => item.main_uuid)];
    this.selectedConditioanl = uniqueKeepLast(this.fieldData?.connected_parent_conditional_id ?? []).filter((field) => {
      const uuid = ['droplist', 'list'].includes(field.type) ? field.main_uuid : field.uuid;
      const isSemiHidden = this.globalService.fields_data[uuid]?.semi_hidden_field === 1;
      return document.querySelector(`.drag-fields[uuid="${uuid}"]`) || isSemiHidden;
    }).filter((item) => selectedUUIDs.includes(item.main_uuid));
  }

  /**
   * active the conditional on field
   * @param event 
   */
  activeConditional(event) {
    this.enable_conditional = (event.target.checked ? 1 : 0);
    this.conditionalService.activeConditionalField(this.enable_conditional, this.fieldData);
    this.selectedConditioanl = [];
  }

  /*
    * auto select the saved fields in the dropdown
   */
  selectedFeildFn = (item, selected) => { if (selected.uuid && item.uuid) { return item.uuid == selected.uuid; } };

  /**
   * Select the field that will link with relation
   * @param field 
   */
  onSelectRelations(fields: ConditioanlsFeilds[]) {
    const updatedField = this.conditionalService.onSelectRelations(fields, this.fieldData);
    this.fieldData = updatedField;
    this.selectedConditioanl = fields;
  }

  /**
   * save to meta data when user want to convert new field into meta data
   * @param type 
   */
  saveToMetaData(type: string) {
    const addToMetaData: NgbModalRef = this.modalService.open(MetaDataFormComponent, { backdrop: 'static' });
    addToMetaData.componentInstance.view = 'modal';
    addToMetaData.componentInstance.meta_data_name = this.labelName;
    addToMetaData.componentInstance.meta_data_type = this.documentfields[type];
    addToMetaData.componentInstance.disabled_meta_data_type = true;
    addToMetaData.componentInstance.options = this.documentfields[type] == "droplist" ? this.setMetaDataOptions() : [];
    addToMetaData.componentInstance.section = "document_field";
    addToMetaData.componentInstance.meta_data_placeholder = this.placeholderName;
    addToMetaData.result.then((metadata: IMetadataItemDto) => {
      if (metadata) {
        const $event: FieldTypes = {
          id: metadata.id,
          name: metadata.meta_data_name,
          description: metadata.meta_data_description,
          multiple_line_field: metadata.multiple_line_field,
          value: ``,
          field_type: this._translocoService.translate("Field setting doc field (Template/Document - section) - Doc field"),
          field_info: "document_field",
          field_required: metadata.is_required ?? 1,
          api_attribute: `${metadata.api_attribute}`,
          prefixid: `d${metadata.id}`,
          multi_select: metadata?.multi_select ?? 0,
          options: metadata.meta_data_option ?? [],
          role_data: {},
          field_section: "document_field",
          validation: metadata.field_validations ?? {},
          placeholder: metadata?.placeholder ?? this.placeholderName,
          source: metadata?.source,
          api_field: metadata?.api_field ?? 0,
          api_url: metadata?.api_url ?? '',
          api_key: metadata?.api_key ?? ''
        };
        this.fieldtype = [...this.fieldtype, $event];
        if (['1', '2', '4'].includes(type)) {
          this.onSelectTypeChange($event);
        } else {
          this.onDroplistTypeChange($event, (type == '3' ? 'droplist' : 'multichoice'));
        }
        // Reload document fields to get the latest metadata
        this.documentFieldsFacade.loadDocumentFields(1);
      }
    });
  }

  setMetaDataOptions() {
    const options = this.getData(this.data['uuid']);
    const createOptions = options.map(option => ({
      id: null,
      name: option.name ?? null,
      value: '',
      show: 0
    }));
    return createOptions;
  }

  /**
   * Removes an existing semi-hidden field from the global fields data if it matches the specified type ID.
   * Searches for a field where semi_hidden_field is set to 1, field_section is 'document_field',
   * and selected_field_type_id matches the provided selectedTypeId.
   * If such a field is found, deletes it using its UUID and returns its value.
   * If no matching field is found, returns null.
   *
   * @param selectedTypeId - The ID of the field type to search for (string or number).
   * @returns The value of the removed field if found, otherwise null.
   */
  private removeExistingSemiHiddenField(selectedTypeId: string | number): string {
    const existingField: Field = Object.values(this.globalService.fields_data).find((field: Field) => field.semi_hidden_field === 1 && field.field_section === 'document_field' && field.selected_field_type_id === selectedTypeId);

    if (!existingField) {
      return '';
    }
    
    const value = existingField?.value;
    this.globalService.deleteField(existingField?.uuid);
    return value ?? '';
  }

  toggleSignatureLabel(event: Event) {
    const isChecked = (event.target as HTMLInputElement).checked;
    this.isLabelHide = isChecked ? 1 : 0;

    const currentElement = document.querySelector(`.drag-fields[uuid="${this.data.uuid}"]`);
    if (!currentElement) {
      return; // safety check
    }

    const assignee = currentElement.querySelector('.assignee') as HTMLElement;
    if (assignee) {
      this.globalService.toggleClass(assignee, 'hidden');
    }

    this.globalService.updateField(this.data.uuid, { hide_label: this.isLabelHide });
  }

  ngOnDestroy() {
    if (this.timeOutSubscription) {
      this.timeOutSubscription.unsubscribe();
    }
    this.destroyed.next();
    this.destroyed.complete();
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }
}
